<template>
  <div>
    <v-main>
      <!-- <v-btn @click="signUp">facebook</v-btn>
      <v-btn @click="signUp2">google</v-btn>
      <v-btn @click="logOut">logOut</v-btn> -->
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <!-- <v-row>
          <v-col>
            <h2>ลิงก์สำหรับลูกค้า</h2>
          </v-col>
        </v-row> -->
        <!-- <v-btn @click="connectToDevice">ddddd</v-btn>
      <v-btn @click="print">print</v-btn> -->
        <v-row style="padding-top: 20px">
          <v-col style="text-align: center">
            <div ref="printMe">
              <h2>{{ text }}</h2>
              <v-select
                v-if="dataLiff"
                hide-details
                :items="dataLiff"
                outlined
                width="200"
                x-large
                item-text="masBranchName"
                item-value="link"
                height="40"
                style="background-color: white !important"
                label="เลือกสาขา"
                dense
                @change="selectBranch"
              ></v-select>
              <br />
              <qrcode-vue
                v-if="!dataLiff && link"
                style="margin-top: 10px"
                :value="link"
                :size="resCol === '12' ? '250' : '330'"
                level="L"
              ></qrcode-vue>
              <qrcode-vue
                v-else-if="dataLiff && link"
                style="margin-top: 10px"
                :value="link"
                :size="resCol === '12' ? '250' : '330'"
                level="L"
              ></qrcode-vue>
              <p v-if="dataLiff && !link">กรุณาเลือกสาขา</p>
            </div>
            <br />
            <v-btn
              v-if="link !== ''"
              elevation="2"
              :style="resCol === '12' ? 'width:85%' : 'min-width:48%'"
              color="#d5d7db"
              @click="generateAndDownloadQR"
            >
              Download
            </v-btn>
          </v-col>
          <v-divider
            vertical
            v-show="resCol === '12' ? false : true"
          ></v-divider>
          <v-col>
            <v-select
              v-model="selectLink"
              :items="items"
              label="ประเภทลิงก์"
              outlined
              x-large
              height="40"
              @change="genLink()"
            ></v-select>
            <div v-if="dataLiff">
              <div v-for="(item, i) in dataLiff " :key="i">
              <p>สาขา {{ item.masBranchName }}</p>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  min-height: 40px;
                "
              >
                <v-text-field
                  v-model="item.link"
                  style="border-radius: 8px 0 0 8px"
                  solo
                  readonly
                  ref="textToCopy"
                  height="40"
                ></v-text-field>
                <v-btn
                  min-height="40"
                  elevation="2"
                  x-large
                  color="success"
                  dark
                  style="border-radius: 0 8px 8px 0; min-height: 40px"
                  @click="textToCopyMulti(item.link)"
                  >คัดลอกลิงก์
                </v-btn>
              </div>
              <!-- {{ link }} -->
            </div>
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                min-height: 40px;
              "
              v-if="!dataLiff"
            >
              <v-text-field
                v-model="link"
                style="border-radius: 8px 0 0 8px"
                solo
                readonly
                ref="textToCopy"
                height="40"
              ></v-text-field>
              <v-btn
                min-height="40"
                elevation="2"
                x-large
                color="success"
                dark
                style="border-radius: 0 8px 8px 0; min-height: 40px"
                @click="textToCopy()"
                >คัดลอกลิงก์
              </v-btn>
            </div>
            <p style="color: rgb(0 0 0 / 50%)">
              *คัดลอก URL จากช่องและเปิดในเบราว์เซอร์
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-left">
            <v-alert
              v-if="alert === false"
              border="left"
              color="green"
              dense
              shaped
              type="success"
              transition="scale-transition"
              >คัดลอกลิ้งสำเร็จ</v-alert
            >
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import html2canvas from 'html2canvas'
import QrcodeVue from 'qrcode.vue'
// import firebase from 'firebase'

// import Vue from 'vue'
const printHelloWorld = async (device) => {
  try {
    console.log('ddd', device)
    const server = await device.gatt.connect()
    console.log('ddd2', server)
    const services = await server.getPrimaryService(
      '49535343-fe7d-4ae5-8fa9-9fafd205e455'
    )
    console.log('services', services)
    let characteristic = await services.getCharacteristic(
      '49535343-8841-43f4-a8d4-ecbe34729bb3'
    )
    console.log('services2222', characteristic.uuid)
    var enc = new TextEncoder()
    let a = enc.encode('Hello, World\n')
    for (var i = 0; a.length; i += 100) {
      await characteristic.writeValueWithoutResponse(a.slice(i, i + 100))
    }
    // Iterate through services to find the desired service
  } catch (error) {
    console.error('Error :ja', error)
  }
}
export default {
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  components: {
    QrcodeVue
  },
  data () {
    return {
      num: 0,
      select: null,
      menu1: false,
      activePicker: null,
      date: null,
      menu: false,
      session: this.$session.getAll(),
      link: '',
      linkAccount: '',
      linkPackage: '',
      output: null,
      QRCODE: '',
      linkFollow: '',
      titel: '',
      oa: '',
      text: '',
      items: [
        { text: 'ลิงก์สำหรับติดตาม LINE OA', value: 'LineOa' },
        { text: 'ลิงก์สำหรับเข้าหน้าหลัก', value: 'Linkmain' },
        { text: 'ลิงก์สำหรับเข้าแพ็กเกจของฉัน', value: 'LinkPackage' },
        { text: 'ลิงก์สำหรับอัปโหลดสลิปเพื่อเพิ่มคะแนน', value: 'LinkSlip' },
        { text: 'ลิงก์สำหรับเข้าหน้ากิจกรรม', value: 'LinkActivity' }
      ],
      selectLink: 'LineOa',
      alert: true,
      dataLiff: null
    }
  },
  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = 'YEAR'))
    }
  },
  async mounted () {
    // firebase.auth()
    //   .getRedirectResult()
    //   .then((result) => {
    //     if (result.credential) {
    //       var credential = result.credential

    //       // This gives you a Facebook Access Token. You can use it to access the Facebook API.
    //       var token = credential.accessToken
    //       console.log(token)
    //       // ...
    //     }
    //     // The signed-in user info.
    //     alert(result)
    //     // IdP data available in result.additionalUserInfo.profile.
    //   // ...
    //   }).catch((error) => {
    //     console.log(error)
    //   })
    // firebase.auth().onAuthStateChanged(function (user) {
    //   if (user) {
    //     // User is signed in.
    //     sessionStorage.setItem('infojaja', JSON.stringify(user))
    //     alert('User is signed in.')
    //     console.log('User is signed in.', user)
    //   } else {
    //     // No user is signed in.
    //     alert('No user is signed in.')
    //     console.log('No user is signed in.')
    //   }
    // }).catch(error => alert(error))
    // alert('test')
    await this.genLink()
    // await this.getDataFollowOA()
    // await this.LinkMain()
    // await this.LinkAccount()
    // await this.LinkPackage()
  },
  methods: {
    // signUp2 () {
    //   let provider = new firebase.auth.GoogleAuthProvider()
    //   console.log('provider', provider)
    //   firebase.auth().signInWithRedirect(provider)
    // },
    // signUp () {
    //   let provider = new firebase.auth.FacebookAuthProvider()
    //   firebase.auth().signInWithRedirect(provider)
    // },
    // logOut () {
    //   firebase
    //     .auth()
    //     .signOut()
    //     .then(() => {
    //       sessionStorage.removeItem('infojaja')
    //       alert('Successfully signed out.')
    //     })
    // },
    selectBranch (item) {
      console.log('ddd2', item)
      this.link = item
    },
    save1 (date) {
      console.log('dddd', date)
      this.$refs.menu1.save(date)
    },
    timeout () {
      this.alert = true
    },
    textToCopyMulti (item) {
      console.log(item)
    },
    textToCopy () {
      try {
        let textToCopyLink = this.$refs.textToCopy.$el.querySelector('input')
        textToCopyLink.select()
        document.execCommand('copy')
        this.alert = false
        setTimeout(this.timeout, 2000)
      } catch (error) {
        console.log('error', error)
      }
    },
    async genLink () {
      try {
        this.dataLiff = null
        if (this.selectLink === 'LineOa') {
          let dataBranch = await axios.get(
            this.DNS_IP +
              '/master_branch/find_setting_liff?shopId=' +
              this.session.data.shopId
          )
          if (Array.isArray(dataBranch.data)) {
            this.link = null
            this.dataLiff = dataBranch.data
            // Create an array to store all axios promises
            let axiosPromises = dataBranch.data.map(async (item) => {
              let data = {
                client_id: item.messagingAPIChannelId,
                client_secret: item.messagingAPIChannelSecret
              }
              console.log('data', data)
              console.log('item.messagingAPIChannelSecret', typeof item.messagingAPIChannelSecret)
              // Return the axios promise
              return axios.get(this.DNS_IP + '/line/getOa/Multi', {
                headers: {
                  clientid: item.messagingAPIChannelId,
                  clientsecret: item.messagingAPIChannelSecret
                }
              })
            })

            // Wait for all axios promises to resolve
            let responses = await Promise.all(axiosPromises)
            console.log('responses', responses)
            // Iterate over the responses and set item.link for each item in this.dataLiff
            responses.forEach((res, index) => {
              this.dataLiff[index].link = 'line://ti/p/' + res.data.basicId
            })

            console.log('aaa', this.dataLiff)
            this.text = 'ลูกค้าติดตาม LINE OA'
          } else {
            // ร้านที่ตั้ง Messaging API ของตัวเอง (lineconfig) ใช้ OA นั้น ไม่งั้นใช้ OA ที่ผูกกับ shopId
            let config = await axios.get(
              'https://api-belinked.betaskthai.tech/lineconfig/get?shopId=' +
                this.session.data.shopId
            )
            let res = Array.isArray(config.data) && config.data[0].messagingAPIChannelId
              ? await axios.get(this.DNS_IP + '/line/getOa/Multi', {
                headers: {
                  clientid: config.data[0].messagingAPIChannelId,
                  clientsecret: config.data[0].messagingAPIChannelSecret
                }
              })
              : await axios.get(this.DNS_IP + '/line/getOa', {
                headers: { botId: this.session.data.shopId }
              })
            this.oa = res.data.basicId
            this.QRCODE = 'line://ti/p/' + res.data.basicId
            this.text = 'ลูกค้าติดตาม LINE OA'
            this.link = 'line://ti/p/' + res.data.basicId
          }
        } else if (this.selectLink === 'Linkmain') {
          let dataBranch = await axios.get(
            this.DNS_IP +
              '/master_branch/find_setting_liff?shopId=' +
              this.session.data.shopId
          )
          if (Array.isArray(dataBranch.data)) {
            this.link = null
            this.dataLiff = dataBranch.data
            this.dataLiff.map((item) => {
              item.link =
                'https://liff.line.me/' +
                item.liffMainIDLoyalty +
                '/home?shopId=' +
                this.session.data.shopId + '&branchId=' +
                item.masBranchID
            })
            // console.log(this.dataLiff)
            this.link = null
            this.text = 'เข้าหน้าหลักตามสาขา'
          } else {
            this.dataLiff = null
            axios
              .get(
                'https://api-belinked.betaskthai.tech/lineconfig/get?shopId=' +
                  this.session.data.shopId
              )
              .then((res) => {
                if (res.data.status === false) {
                  this.link =
                    'https://liff.line.me/1656906322-JN5MM8Ep/home?shopId=' +
                    this.session.data.shopId +
                    '&type=welcome'
                } else {
                  if (res.data.liffMainIDLoyalty === null) {
                    this.link =
                      'https://liff.line.me/1656906322-JN5MM8Ep/home?shopId=' +
                      this.session.data.shopId +
                      '&type=welcome'
                  } else {
                    if (
                      this.session.data.shopId ===
                        'U97dd281445cde30a599a5f5515a4e937' ||
                      this.session.data.shopId ===
                        'U60f3a4215c86a978d5f6191292ad0109'
                    ) {
                      this.link =
                        'https://liff.line.me/' +
                        res.data[0].liffMainIDLoyalty +
                        '/home?shopId=' +
                        this.session.data.shopId
                    } else {
                      this.link =
                        'https://liff.line.me/' +
                        res.data[0].liffMainIDLoyalty +
                        '/home?shopId=' +
                        this.session.data.shopId
                    }
                  }
                }
                this.text = 'เข้าหน้าหลัก'
              })
          }
        } else if (this.selectLink === 'LinkPackage') {
          let dataBranch = await axios.get(
            this.DNS_IP +
              '/master_branch/find_setting_liff?shopId=' +
              this.session.data.shopId
          )
          if (Array.isArray(dataBranch.data)) {
            this.link = null
            this.dataLiff = dataBranch.data
            this.dataLiff.map((item) => {
              item.link =
                'https://liff.line.me/' +
                item.liffMainIDLoyalty +
                '/MyPackage?shopId=' +
                this.session.data.shopId + '&branchId=' +
                item.masBranchID
            })
            // console.log(this.dataLiff)
            this.link = null
            this.text = 'แพ็กเกจของฉัน'
          } else {
            axios
              .get(
                'https://api-belinked.betaskthai.tech/lineconfig/get?shopId=' +
                  this.session.data.shopId
              )
              .then((res) => {
                if (res.data.status === false) {
                  this.link =
                    'https://liff.line.me/1656906322-JN5MM8Ep/MyPackage?shopId=' +
                    this.session.data.shopId
                } else {
                  if (res.data.liffMainIDLoyalty === null) {
                    this.link =
                      'https://liff.line.me/1656906322-JN5MM8Ep/MyPackage?shopId=' +
                      this.session.data.shopId
                  } else {
                    this.link =
                      'https://liff.line.me/' +
                      res.data[0].liffMainIDLoyalty +
                      '/MyPackage?shopId=' +
                      this.session.data.shopId
                  }
                }
                this.text = 'แพ็กเกจของฉัน'
              })
          }
        } else if (this.selectLink === 'LinkActivity') {
          let dataBranch = await axios.get(
            this.DNS_IP +
              '/master_branch/find_setting_liff?shopId=' +
              this.session.data.shopId
          )
          if (Array.isArray(dataBranch.data)) {
            this.link = null
            this.dataLiff = dataBranch.data
            this.dataLiff.map((item) => {
              item.link =
                'https://liff.line.me/' +
                item.liffMainIDLoyalty +
                '/activity?shopId=' +
                this.session.data.shopId + '&branchId=' +
                item.masBranchID
            })
            this.text = 'หน้ากิจกรรมตามสาขา'
          } else {
            // ร้านที่ตั้ง LINE ของตัวเองใช้ LIFF ของร้าน ไม่งั้นใช้ LIFF กลาง
            let res = await axios.get(
              'https://api-belinked.betaskthai.tech/lineconfig/get?shopId=' +
                this.session.data.shopId
            )
            const liffId =
              Array.isArray(res.data) && res.data[0].liffMainIDLoyalty
                ? res.data[0].liffMainIDLoyalty
                : '1656906322-JN5MM8Ep'
            this.link =
              'https://liff.line.me/' +
              liffId +
              '/activity?shopId=' +
              this.session.data.shopId
            this.text = 'หน้ากิจกรรม'
          }
        } else {
          let dataBranch = await axios.get(
            this.DNS_IP +
              '/master_branch/find_setting_liff?shopId=' +
              this.session.data.shopId
          )
          if (Array.isArray(dataBranch.data)) {
            this.link = null
            this.dataLiff = dataBranch.data
            this.dataLiff.map((item) => {
              item.link =
                'https://liff.line.me/' +
                item.liffMainIDLoyalty +
                '/UploadPaymentForPoint?shopId=' +
                this.session.data.shopId + '&branchId=' +
                item.masBranchID
            })
            // console.log(this.dataLiff)
            this.link = null
            this.text = 'อัปโหลดสลิปเพื่อเพิ่มคะแนน'
          } else {
            axios
              .get(
                'https://api-belinked.betaskthai.tech/lineconfig/get?shopId=' +
                  this.session.data.shopId
              )
              .then((res) => {
                if (res.data.status === false) {
                  this.link =
                    'https://liff.line.me/1656906322-JN5MM8Ep/UploadPaymentForPoint?shopId=' +
                    this.session.data.shopId
                } else {
                  if (res.data.liffMainIDLoyalty === null) {
                    this.link =
                      'https://liff.line.me/1656906322-JN5MM8Ep/UploadPaymentForPoint?shopId=' +
                      this.session.data.shopId
                  } else {
                    this.link =
                      'https://liff.line.me/' +
                      res.data[0].liffMainIDLoyalty +
                      '/UploadPaymentForPoint?shopId=' +
                      this.session.data.shopId
                  }
                }
                this.text = 'อัปโหลดสลิปเพื่อเพิ่มคะแนน'
              })
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    getDataFollowOA () {
      axios
        .get(this.DNS_IP + '/line/getOa', {
          headers: {
            botId: this.session.data.shopId
          }
        })
        .then((res) => {
          console.log(res.data)
          this.oa = res.data.basicId
          this.QRCODE = 'line://ti/p/' + res.data.basicId
          this.text = 'ลูกค้าติดตาม LINE OA'
          console.log(this.linkFollow)
        })
    },
    textToCopyFollowOA () {
      this.getDataFollowOA()
      let textToCopyFollowOA =
        this.$refs.textToCopyFollowOA.$el.querySelector('input')
      textToCopyFollowOA.select()
      document.execCommand('copy')
      this.$swal({
        title: 'Copy successfully',
        text: 'คัดลอกลิ้งสำเร็จ',
        type: 'success',
        timer: 2000,
        showConfirmButton: false
      })
      this.QRCODE = 'line://ti/p/' + this.oa
      this.text = 'ลูกค้าติดตาม LINE OA'
    },
    textToCopyLinkMain () {
      let textToCopyLinkMain =
        this.$refs.textToCopyLinkMain.$el.querySelector('input')
      textToCopyLinkMain.select()
      document.execCommand('copy')
      this.$swal({
        title: 'Copy successfully',
        text: 'คัดลอกลิ้งสำเร็จ',
        type: 'success',
        timer: 2000,
        showConfirmButton: false
      })
      this.QRCODE = this.linkMain
      this.text = 'สำหรับเข้าหน้าหลัก'
    },
    textToCopyLinkAccount () {
      let textToCopyLinkAccount =
        this.$refs.textToCopyLinkAccount.$el.querySelector('input')
      textToCopyLinkAccount.select()
      document.execCommand('copy')
      this.$swal({
        title: 'Copy successfully',
        text: 'คัดลอกลิ้งสำเร็จ',
        type: 'success',
        timer: 2000,
        showConfirmButton: false
      })
      this.QRCODE = this.linkAccount
      this.text = 'สำหรับเข้าบัญชี'
    },
    textToCopyLinkPackage () {
      let textToCopyLinkPackage =
        this.$refs.textToCopyLinkPackage.$el.querySelector('input')
      textToCopyLinkPackage.select()
      document.execCommand('copy')
      this.$swal({
        title: 'Copy successfully',
        text: 'คัดลอกลิ้งสำเร็จ',
        type: 'success',
        timer: 2000,
        showConfirmButton: false
      })
      this.QRCODE = this.linkPackage
      this.text = 'สำหรับเข้าแพ็กเกจของฉัน'
    },
    LinkMain () {
      axios
        .get(
          'https://api-belinked.betaskthai.tech/lineconfig/get?shopId=' +
            this.session.data.shopId
        )
        .then((res) => {
          if (res.data.status === false) {
            this.linkMain =
              'https://liff.line.me/1656906322-JN5MM8Ep/home?shopId=' +
              this.session.data.shopId +
              '&type=welcome'
          } else {
            if (res.data.liffMainIDLoyalty === null) {
              this.linkMain =
                'https://liff.line.me/1656906322-JN5MM8Ep/home?shopId=' +
                this.session.data.shopId +
                '&type=welcome'
            } else {
              this.linkMain =
                'https://liff.line.me/' +
                res.data[0].liffMainIDLoyalty +
                '/home?shopId=' +
                this.session.data.shopId
            }
          }
        })
    },
    LinkAccount () {
      axios
        .get(
          'https://api-belinked.betaskthai.tech/lineconfig/get?shopId=' +
            this.session.data.shopId
        )
        .then((res) => {
          if (res.data.status === false) {
            this.linkAccount =
              'https://liff.line.me/1656906322-JN5MM8Ep/card?shopId=' +
              this.session.data.shopId
          } else {
            if (
              res.data.liffMainIDLoyalty === null ||
              res.data.liffMainIDLoyalty === ''
            ) {
              this.linkAccount =
                'https://liff.line.me/1656906322-JN5MM8Ep/card?shopId=' +
                this.session.data.shopId
            } else {
              this.linkAccount =
                'https://liff.line.me/' +
                res.data[0].liffMainIDLoyalty +
                '/card?shopId=' +
                this.session.data.shopId
            }
          }
        })
    },
    LinkPackage () {
      axios
        .get(
          'https://api-belinked.betaskthai.tech/lineconfig/get?shopId=' +
            this.session.data.shopId
        )
        .then((res) => {
          if (res.data.status === false) {
            this.linkPackage =
              'https://liff.line.me/1656906322-JN5MM8Ep/MyPackage?shopId=' +
              this.session.data.shopId
          } else {
            if (res.data.liffMainIDLoyalty === null) {
              this.linkPackage =
                'https://liff.line.me/1656906322-JN5MM8Ep/MyPackage?shopId=' +
                this.session.data.shopId
            } else {
              this.linkPackage =
                'https://liff.line.me/' +
                res.data[0].liffMainIDLoyalty +
                '/MyPackage?shopId=' +
                this.session.data.shopId
            }
          }
        })
    },
    // async DonwloadQRCODE () {
    //   const el = this.$refs.printMe
    //   const options = {
    //     type: 'dataURL'
    //   }
    //   this.output = await this.$html2canvas(el, options)
    //   // await this.print()
    //   await axios({
    //     url: this.output,
    //     method: 'GET',
    //     responseType: 'blob'
    //   }).then(response => {
    //     let fileUrl = window.URL.createObjectURL(new Blob([response.data]))
    //     let fileLink = document.createElement('a')
    //     fileLink.href = fileUrl
    //     let fieldName = Date.now()
    //     fileLink.setAttribute('download', 'QR CODE ' + fieldName + '.jpg')
    //     document.body.appendChild(fileLink)

    //     fileLink.click()
    //   })
    // },
    // async print () {
    //   const el = this.$refs.printMe
    //   const options = {
    //     type: 'dataURL'
    //   }
    //   this.output = await this.$html2canvas(el, options)
    //   console.log('22', await this.$html2canvas(el, options))
    // },
    async generateAndDownloadQR () {
      const el = this.$refs.printMe
      const options = {
        type: 'dataURL'
      }

      try {
        const canvas = await html2canvas(el, options)
        const dataUrl = canvas.toDataURL('image/jpeg')

        const response = await axios.get(dataUrl, {
          responseType: 'blob'
        })

        const blob = new Blob([response.data], { type: 'image/jpeg' })
        const url = window.URL.createObjectURL(blob)

        const fileLink = document.createElement('a')
        fileLink.href = url

        const fieldName = Date.now()
        fileLink.setAttribute('download', 'QR_CODE_' + fieldName + '.jpg')
        document.body.appendChild(fileLink)

        fileLink.click()
      } catch (error) {
        console.error('Error generating and downloading QR code:', error)
      }
      //   console.log('dd')
      this.output = await this.$html2canvas(el, options)
      console.log('this.output', this.output)
    },
    async connectToDevice () {
      navigator.bluetooth
        .requestDevice({
          acceptAllDevices: true,
          optionalServices: ['49535343-fe7d-4ae5-8fa9-9fafd205e455']
        })
        .then((device) => printHelloWorld(device))
        .catch((error) => console.error('Request device error:', error))
      // filters: [{ services: ['8fe6819d-d5f9-49fa-90ba-4da05a7d2725'] }]
      // try {
      //   navigator.bluetooth.requestDevice({
      //     // filters: [{ services: ['8fe6819d-d5f9-49fa-90ba-4da05a7d2725'] }]
      //     acceptAllDevices: true // You can also use 'filters' to specify the service
      //   })
      //     .then((device) => {
      //       console.log(device)
      //       device.gatt.connect()
      //       this.device = device
      //     })
      //     // .then(service => {
      //     //   // Getting Battery Level Characteristic…
      //     //   return service.getCharacteristic('battery_level')
      //     // })
      //     // .then(characteristic => {
      //     //   // Reading Battery Level…
      //     //   return characteristic.readValue()
      //     // })
      //     // .then(value => {
      //     //   console.log(`Battery percentage is ${value.getUint8(0)}`)
      //     // })
      //     .catch(error => { console.error(error) })
      // } catch (error) {
      //   console.error('Error connecting to Bluetooth device:', error)
      // }
    }
  }
}
</script>
<style scoped>
.v-text-field > .v-input__control > .v-input__slot {
  cursor: text;
  height: 52px !important;
}
.v-text-field.v-text-field--enclosed {
  margin: 0;
  padding: 0 !important;
}
.bg-img {
  background: url("https://d.line-scdn.net/stf/linecorp/th/pr/SMCHUpdateNewLINEVersion.png")
    no-repeat center center;
}
.v-btn:not(.v-btn--round).v-size--x-large {
  height: 48px !important;
  max-width: 110px !important;
  padding: 0 23.1111111111px;
}
.v-alert {
  position: fixed;
  left: 90%;
  bottom: 50px;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  width: 220px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/System/link.vue